import { DropdownWithSearch } from "InnoUI/innoinput";
import { calendarDays, folderTypes } from "utils/optionData/utils";

const FolderTypeDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
}) => {
  const projectOptions = folderTypes.map((data) => ({
    id: data.id,
    label: data.name,
    icon: data.icon,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = projectOptions.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      options={projectOptions}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={disabled}
      width="340px"
      dropdowType={name}
    />
  );
};

export default FolderTypeDropdown;
